<template>
  <CreateOrderLayout :disable-next-btn="isNextBtnDisabled" @next="next">
    <div class="kt-portlet">
      <div class="kt-portlet__body h-100 p-0">
        <UploadOrderImageUppy
          @processing="uploadingImage = true"
          @complete="uploadingImage = false"
        />
      </div>
    </div>

    <div class="kt-portlet">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-xl-6">
            <div class="form-group">
              <label class="col-form-label">Order Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="Your order name here ..."
                v-model="name"
                ref="orderName"
              />
            </div>
            <div>
              <label class="col-form-label">Order Instructions</label>
              <textarea
                class="form-control"
                placeholder="Enter your order instruction here ..."
                rows="4"
                v-model="instruction"
              ></textarea>
            </div>
          </div>

          <div class="col-xl-6">
            <UploadOrderSampleImagesUppy
              class="mt-4 px-4"
              @processing="uploadingImage = true"
              @complete="uploadingImage = false"
            />
          </div>
        </div>
      </div>
    </div>
  </CreateOrderLayout>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import loading from "@/assets/loading/loading.gif";
import CreateOrderLayout from "@/layouts/CreateOrderLayout.vue";
import UploadOrderSampleImagesUppy from "@/components/UploadOrderSampleImagesUppy.vue";
import UploadOrderImageUppy from "@/components/UploadOrderImageUppy.vue";
import BeforeLeaveOrderFormMixin from "@/mixins/beforeLeaveOrderForm.js";
import OrderStatusMixin from "@/mixins/orderStatus.js";

export default {
  name: "StepOne",
  components: {
    CreateOrderLayout,
    UploadOrderSampleImagesUppy,
    UploadOrderImageUppy,
  },
  mixins: [BeforeLeaveOrderFormMixin, OrderStatusMixin],
  data() {
    return {
      loading,
      name: "",
      instruction: "",
      selectedImageId: null,
      selectedImageName: null,
      selectedImageInstruction: "",

      uuid: null,
      uploadingImage: false,
    };
  },

  computed: {
    ...mapGetters({
      options: "upload/options",
      orderName: "order/name",
      service: "service/service",
      orderInstruction: "order/instruction",
      images: "order/images",
      orderUuid: "order/uuid",
    }),

    isNextBtnDisabled() {
      if (this.uploadingImage || this.name == "" || this.images.length == 0) {
        return true;
      }

      return false;
    },
  },

  watch: {
    name(newValue) {
      this.setName({
        name: newValue,
      });
    },
    instruction(newValue) {
      this.setInstruction({
        instruction: newValue,
      });
    },
    $route() {
      this.$refs.orderName.focus();
    },
  },

  created() {
    this.setUrl({
      url: process.env.VUE_APP_API_URL + "/images",
    });
  },

  mounted() {

    const orderID = this.$route.query?.order || null;
    if (orderID) {
      axios.get("orders/" + orderID).then((response) => {
        if (!this.isDraft(response.data) && !this.isPending(response.data)) {
          this.$router.push({name: "home"});
          return;
        }
        this.setOrder(response.data);
        this.name = this.orderName;
        this.instruction = this.orderInstruction;
        this.uuid = this.orderUuid;
      });
    } else {
      this.name = this.orderName;
      this.instruction = this.orderInstruction;
      this.uuid = this.orderUuid;
    }

    // this.dz = this.$refs.dz;
    this.$refs.orderName.focus();
  },

  methods: {
    ...mapActions({
      setOrder: "order/setOrder",
      setUuid: "order/setUuid",
      setName: "order/setName",
      setInstruction: "order/setInstruction",
      setImage: "order/setImage",
      setUrl: "upload/setUrl",
      updateImage: "order/updateImage",
      deleteImage: "order/deleteImage",
    }),

    next() {
      let errMsg = null;

      if (this.name == "") {
        errMsg = "Please fill up order name!";
      }
      if (this.images.length == 0) {
        errMsg = "Please add order image!";
      }
      if (errMsg) {
        this.$swal({ icon: "error", title: "Oops...", text: errMsg });
        return;
      }

      this.$router.push({
        name: "step-two",
        params: { slug: this.service.slug },
        query: { ...this.$route.query },
      });
    },
  },
};
</script>
